/**
 * Adds a row-index to data-table-rows on slot change
 */
function setDataTableRowIndicesOnSlotChange(event) {
  const assignedElements = event.target.assignedElements();
  for (let index = 0; index < assignedElements.length; index++) {
    const dataTableRow = assignedElements[index];
    dataTableRow.setAttribute('row-index', `${index}`);
  }
}
/**
 * Adds a cell-index to data-table-cells on slot change
 */
function setDataTableCellIndicesOnSlotChange(event) {
  const assignedElements = event.target.assignedElements();
  for (let index = 0; index < assignedElements.length; index++) {
    const dataTableCell = assignedElements[index];
    dataTableCell.setAttribute('cell-index', `${index}`);
  }
}

export { setDataTableCellIndicesOnSlotChange as a, setDataTableRowIndicesOnSlotChange as s };

//# sourceMappingURL=cl-data-table.utils.js.map